import React, {
	createContext,
	type MutableRefObject,
	type ReactElement,
	type RefObject,
	useRef,
} from 'react';

const ScrollableParentContext = createContext<RefObject<HTMLElement | null>>({ current: null });

export const ScrollableParentProvider = ({
	children,
}: {
	children: (scrollableParent: RefObject<HTMLElement | null>) => ReactElement;
}) => {
	const scrollableParent: MutableRefObject<HTMLElement | null> = useRef<HTMLElement | null>(null);
	return (
		<ScrollableParentContext.Provider value={scrollableParent}>
			{children(scrollableParent)}
		</ScrollableParentContext.Provider>
	);
};

export const ScrollableParentConsumer = ScrollableParentContext.Consumer;
